@for (domainPlatformKey of domainPlatformListGroup | keys; track domainPlatformKey) {
  <div class="super-app-group">
    <div class="s-app-group-label">{{domainPlatformKey}}</div>
    @if (appLoaded) {
      <div class="super-app-items">
        @for (domainPlatform of domainPlatformListGroup[domainPlatformKey]; track domainPlatform) {
          <div class="super-app-item {{(domainPlatform.key == appService._curApp)?'active':''}}"
            (click)="openDomainPlatformApp(domainPlatform)">
            <div class="s-app-item">
              <div class="_s-app-img">
                <img [src]="utilService.getImageUrl(domainPlatform.icon)" class="_s-app-icon">
              </div>
              <div class="_s-app-title">
                {{domainPlatform.name}}
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}